import axios from 'axios';

export class ContentRetriever {
	public static async getContent (sourceId: string): Promise<string> {
		const response = await axios({
			method: 'get',
			url: `/CatalogSearch/Help/${sourceId}`
		});

		return response.data;
	}
}
